import { takeLatest, all, put, call } from "redux-saga/effects";
import { get } from "../../services/httpService";
import environment from "../../config/environment";
import {
  appConfigFailure,
  appConfigSuccess,
  APP_CONFIG_REQUEST,
} from "../Actions/appConfigActions";
import { normalizeData } from "../Actions/normalizrActions";
import { websiteConfigSchema } from "../Schemas/websiteConfigSchema";
import { supplierSettingsSuccess } from "../Actions/supplierSettingsActions";
import { setSupplierSubscription } from "../Actions/subscriptionActions";
import { setSupplierHasDiscounts } from "../Actions/supplierDiscountsActions";

// Si la consulta falla se asume que hay descuentos: el campo se muestra como
// siempre y el error no tira la carga del sitio.
export function* fetchSupplierHasDiscounts(supplierId) {
  try {
    const response = yield call(
      get,
      `${environment.api.apiBaseUrl}/api/discount`,
      {
        params: {
          filters: { owner: supplierId, active: true },
          fields: ["_id"],
          limit: 1,
        },
      }
    );
    return response.data.totalDocs > 0;
  } catch (err) {
    console.log(err);
    return true;
  }
}

export function* handleAppConfigRequest(action) {
  try {
    const { domain } = action.payload;
    const response = yield call(
      get,
      `${environment.api.apiBaseUrl}/api/websiteconfigs/domain`,
      {
        params: {
          domain,
          relationships: ["supplier"],
        },
      }
    );
    const config = response.data;
    const [settingsResponse, supplierSubscription, hasDiscounts] = yield all([
      call(
        get,
        `${environment.api.apiBaseUrl}/api/v2/suppliers/${config.supplier._id}/settings`
      ),
      call(
        get,
        `${environment.api.apiBaseUrl}/api/subscriptions/${config.supplier.subscription}/features`
      ),
      call(fetchSupplierHasDiscounts, config.supplier._id),
    ]);
    yield put(normalizeData(config, websiteConfigSchema));
    yield put(setSupplierHasDiscounts(hasDiscounts));
    yield put(appConfigSuccess(config._id));
    yield put(
      supplierSettingsSuccess({
        ...settingsResponse.data,
      })
    );
    yield put(setSupplierSubscription(supplierSubscription.data));
  } catch (err) {
    yield put(appConfigFailure(err));
    console.log(err);
  }
}

export default function* appConfigSaga() {
  yield all([takeLatest(APP_CONFIG_REQUEST, handleAppConfigRequest)]);
}
